/*=========================================================================================
  File Name: moduletimeTableActions.js
  Description: timeTable Module Actions
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import axios from "@/axios.js"

export default {
  editTimeTableSetting(context, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/user/timetable/setting/update", payload)
        .then((response) => {
          if(response.data.result == 'success'){
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getTimeTableSetting(context, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/user/timetable/setting/"+payload)
        .then((response) => {
          if(response.data.result == 'success'){
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  createTimeTable({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/user/timetable/create", payload)
        .then((response) => {
          if(response.data.result == 'success'){
            commit('CREATE_SCHEDULE', response.data.data)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  updateTimeTable({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.post("/api/user/timetable/update", payload)
        .then((response) => {
          if(response.data.result == 'success'){
            commit('UPDATE_SCHEDULE', payload)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  deleteTimeTable(context, payload) {
    return new Promise((resolve, reject) => {
      axios.delete("/api/user/timetable/"+payload)
        .then((response) => {
          if(response.data.result == 'success'){
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
  getTimeTable({ commit }, payload) {
    return new Promise((resolve, reject) => {
      axios.get("/api/user/timetable/"+payload)
        .then((response) => {
          if(response.data.result == 'success'){            
            commit('SET_SCHEDULE', response.data.data_list)
            resolve(response)
          }
          reject(response)
        })
        .catch((error) => { reject(error) })
    })
  },
}
